import * as _ from 'lodash';

import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { AvailableLanguage, getRequestedAvailableLanguages } from 'helpers/language';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'fc-language-selector-v2',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LanguageSelectorComponent implements OnChanges {
    public languages: Language[] = [];
    public selectedIcon = null;
    public languageForm: FormGroup;

    @Input() public initialLanguage: AvailableLanguage = AvailableLanguage.De;
    @Input() public languageGroup = null;
    @Output() public onLanguageSelected = new EventEmitter();

    constructor(private formBuilder: FormBuilder) {
        const availableLanguages = getRequestedAvailableLanguages([
            AvailableLanguage.En,
            AvailableLanguage.De,
            AvailableLanguage.Nl
        ]);
        this.languages = _.keys(availableLanguages).map((language) => ({
            label: availableLanguages[language].name,
            value: language,
            icon: `assets/svg/flags/${availableLanguages[language].flag}.svg`,
            isCustomIcon: true,
            iconStyle: { width: '16px', height: '16px', borderRadius: '2px' }
        }));

        const selectedLanguage = _.find(this.languages, { value: this.initialLanguage });
        this.selectedIcon = selectedLanguage.icon;
        this.languageForm = this.formBuilder.group({
            preferredLanguage: new FormControl(selectedLanguage)
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        const selectedLanguage = _.find(this.languages, { value: changes.initialLanguage.currentValue });
        this.languageForm.get('preferredLanguage').setValue(selectedLanguage);
        this.onLanguageChange(selectedLanguage);
    }

    public onLanguageChange(languageEvent) {
        this.selectedIcon = languageEvent.icon;
        this.onLanguageSelected.emit(languageEvent);
    }
}

export type Language = {
    label: string;
    value: string;
    icon: string;
    isCustomIcon: boolean;
    iconStyle?: any;
};
